import { styled } from '@mui/material/styles'

export const NotificationsMenuStyle = styled('div')`
  display: flex;
  flex-direction: column;
  position: absolute;
  border: 1px solid #f4f4f4;
  border-radius: 5%;
  box-shadow: ${({ theme }) => theme.shadows[2]};
  align-items: flex-start;
  right: -165px;
  top: 40px;
  width: 380px;
  min-height: 274px;
  max-height: 451px;
  background-color: #ffffff;
  overflow: auto;
  z-index: 10;
`
